import React from 'react'
import {Context as AppContext} from '../../contexts/App'

import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

const CurrencySelection = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { currencies } = app.currencies
  const { selectedProducts, setSelectedProducts, assignCurrency } = app.products

  const title = selectedProducts?`Asignar moneda a ${selectedProducts.length} producto${selectedProducts.length>1?'s':''}`:''
  return (
    <Dialog onClose={() => setSelectedProducts(false)} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <List sx={{ pt: 0 }}>
        {currencies.map((currency) => (
          <ListItem button onClick={() => {close();assignCurrency(currency.id);}} key={currency.name}>
            <ListItemText primary={currency.name} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  )
}
export default CurrencySelection